/**
 * T-145: Granular scroll-depth tracking for GA4
 * Fires scroll_25, scroll_50, scroll_75 on product pages only.
 * scroll_90 is already covered by GA4 Enhanced Measurement — not duplicated here.
 * Each milestone fires exactly once per page load.
 */
(function () {
  var fired = {};
  var milestones = [25, 50, 75];

  function getScrollPct() {
    var el = document.documentElement;
    var scrollable = el.scrollHeight - el.clientHeight;
    if (scrollable <= 0) return 100;
    return Math.round((window.scrollY / scrollable) * 100);
  }

  // #150 Task 7: measure once per frame, not per scroll event. Each read forced a style recalculation
  // mid-scroll (~170 ms on a 4x-throttled phone), which delayed the next tap on the page.
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(check);
  }

  function check() {
    ticking = false;
    var pct = getScrollPct();
    for (var i = 0; i < milestones.length; i++) {
      var m = milestones[i];
      if (!fired[m] && pct >= m) {
        fired[m] = true;
        if (typeof gtag === 'function') {
          gtag('event', 'scroll_' + m, {
            percent_scrolled: m,
            page_path: window.location.pathname
          });
        }
      }
    }
    // Detach once all milestones fired
    if (fired[25] && fired[50] && fired[75]) {
      window.removeEventListener('scroll', onScroll, { passive: true });
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
})();
